import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=d40e4ba8&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d40e4ba8')) {
      api.createRecord('d40e4ba8', component.options)
    } else {
      api.reload('d40e4ba8', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=d40e4ba8&", function () {
      api.rerender('d40e4ba8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26GQ6lqh8qp9c/JS/comp/ImageCarousel.vue"
export default component.exports